import React from 'react';
import { View, Image, StyleSheet, Platform } from 'react-native';
import { FontAwesome6 } from '@expo/vector-icons';
import { colors } from '../../styles/theme';
import { TemplateState } from '../../types';

interface TemplateThumbnailProps {
  state: TemplateState;
  thumbnailUrl: string;
  localSnapshotUri?: string | null;
  size?: number;
}

export default function TemplateThumbnail({ state, thumbnailUrl, localSnapshotUri, size = 100 }: TemplateThumbnailProps) {
  const imageSource = (state === 'COMPLETED' && localSnapshotUri && localSnapshotUri !== 'completed')
    ? { uri: localSnapshotUri }
    : { uri: thumbnailUrl };

  return (
    <View style={[styles.container, { width: size, height: size }]}>
      <Image
        source={imageSource}
        style={[
          styles.image,
          state === 'UNPLAYED' && styles.unplayedImage,
          state === 'LOCKED' && styles.lockedImage
        ]}
      />

      {state === 'LOCKED' && (
        <View style={styles.overlay}>
          <FontAwesome6 name="lock" size={size * 0.3} color="rgba(255,255,255,0.8)" solid />
        </View>
      )}

      {state === 'COMPLETED' && (
        <View style={styles.overlay}>
          <FontAwesome6 name="circle-check" size={size * 0.35} color="rgba(255,255,255,0.7)" solid />
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#eee',
    borderRadius: 12,
    overflow: 'hidden',
    position: 'relative',
    borderWidth: 1,
    borderColor: colors.border,
  },
  image: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
  },
  unplayedImage: {
    opacity: 0.4,
    ...Platform.select({
      web: {
        filter: 'grayscale(100%)',
      } as any,
    }),
  },
  lockedImage: {
    opacity: 0.6,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.3)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  badge: {
    position: 'absolute',
    bottom: 4,
    right: 4,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow: '0px 2px 2px rgba(0,0,0,0.2)',
    elevation: 3,
  }
});
